// Переключатель дизайна: classic (по умолчанию) / cp. Старая версия — RackCall.classic.js, новая — RackCall.cp.js
import { isCp } from 'libs/design';
import * as classic from './RackCall.classic';
import * as cp from './RackCall.cp';

export const RackCall = isCp ? cp.RackCall : classic.RackCall;
